import { ZodIssue, ZodSchema } from "zod";

export const validateForm = <T>(
  values: Record<string, any>,
  schema: ZodSchema<T>
) => {
  const result = schema.safeParse(values);

  return result.success
    ? []
    : result.error.errors
        .map((e: ZodIssue) => ({
          [e.path[0]]: e.message,
        }))
        .reduce(
          (
            accumulator: { [x: string]: string },
            currentValue: { [x: string]: string }
          ) => ({
            ...accumulator,
            ...currentValue,
          }),
          {}
        );
};
